import React from "react";
import { Modal } from "antd";

// 模态框引用
let modalRef: ReturnType<typeof Modal.error> = null;

// 显示错误弹框， 阻断操作
export function showErrorModal(title: React.ReactNode = "错误信息", msg?: React.ReactNode) {
  if (!modalRef) {
    modalRef = Modal.error({
      title,
      content: msg,
      okCancel: false,
      okText: "知道了",
      onCancel() {
        modalRef = null;
      },
      onOk() {
        modalRef = null;
      },
    });
  } else {
    modalRef.update({
      content: msg,
    });
  }
}

// 登录过期弹窗
export function showLoginExpiryModal() {
  const info = {
    title: "登录过期，请重新登录",
    okText: "去登录",
    onOk() {
      window.location.href = "/login";
    },
  };

  if (!modalRef) {
    modalRef = Modal.error(info);
  } else {
    modalRef.update(info);
  }
}
